<template xmlns="http://www.w3.org/1999/html">
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="form-heading title-section form-section flex">
            <h1 class="form-title">Easy Financing Through OREP</h1>
          </article>
          <article class="input-section form-section">
            <div>
              <p>The minimum premium that can be financed is $500. If you are interested in financing, please click to request financing below.</p>

              <p>
                <strong>
                  Steps to Finance Your Premium:
                </strong>

              </p>
              <ol>
                <li style="padding-bottom:1em;font-size: 20px;"> Click the button below to Request Financing.</li>
                <li style="padding-bottom:1em;font-size: 20px;">We will email you a no-obligation finance agreement for your review and signature, along with a payment page/link.</li>
                <li style="padding-bottom:1em;font-size: 20px;">To finance, simply sign the finance agreement and use the payment page or link to send the down payment indicated.</li>
                <li style="padding-bottom:1em;font-size: 20px;">Once we receive your signed finance agreement and down-payment, we will finalize your insurance. Policies typically are sent within 1 business day.</li>
              </ol>

              <p>
                <strong style="text-decoration: underline">
                  <i>Important: </i>
                </strong>
                Please retain a copy of your finance agreement, including the terms and contact information.
                Financing issues can only be resolved by contacting the finance company directly.
              </p>
              <p>
                Receive fast, personal service from the OREP staff who have been serving appraisers, inspectors and other real estate professionals for over 20 years.
              </p>
              <p>
                Feel free to call us <strong>Toll Free: (888) 347-5273.</strong> We're here to help!
              </p>
            </div>
            <div class="mt-5 d-flex justify-content-center">
              <button class="btn btn-secondary btn-lg" @click="emailGeneration()">
                Request Financing
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Sending an email...</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "rx-application-request-financing",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      rxApplication() {
        return this.$store.state.rxApplication.rxApplication;
      },
      state() {
        return this.$store.state.rxApplication;
      },
      errorMsg() {
        return this.$store.state.rxApplication.errorMsg;
      },
      // successMsg() {
      //   return this.$store.state.rxApplication.successMsg;
      // }
    },
    methods: {
      emailGeneration() {
        this.loading = true;
        this.$store.dispatch('rxApplication/requestFinanceAgreement', {id: this.$route.params.id});
      }
    },
    watch: {
      errorMsg: {
        handler() {
          this.loading = false;
          if (this.errorMsg) {
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      },
      // successMsg: {
      //   handler() {
      //     this.loading = false;
      //     if (this.successMsg) {
      //       this.$notify({
      //         group: 'error',
      //         type: 'success',
      //         text: this.successMsg
      //       });
      //     }
      //   }
      // }
    },
  }
</script>

<style scoped>
  p {
    font-size: 20px;
  }
</style>
